export default "__VITE_ASSET__DXToaKQ3__"